'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M960 256h-896l64-128h352l32 64h416zM0 320l64 640h896l64-640h-1024zM576 704v191.016h-128v-191.016h-224l288-288 288 288h-224z' })
    ));
};